import { render, staticRenderFns } from "./merchant-summary-card.vue?vue&type=template&id=f29b5350&scoped=true&lang=pug"
import script from "./merchant-summary-card.vue?vue&type=script&lang=ts"
export * from "./merchant-summary-card.vue?vue&type=script&lang=ts"
import style0 from "./merchant-summary-card.vue?vue&type=style&index=0&id=f29b5350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29b5350",
  null
  
)

export default component.exports